module.exports = __webpack_public_path__ + "img/ben.c81e8915.svg";